import { vehicleOutlinePlaceholders } from "./vehicleOutlinePlaceholders";

// gambar_depan/kiri/kanan/belakang -> "depan"/"kiri"/"kanan"/"belakang"
const sideOf = (field) => field.replace(/^gambar_(box_)?/, "");

// The "Model 2D" reference shown until a real photo (gambar_*) exists: prefer the uploaded jenis_mobil master
// data photo (data_kendaraan.data_jenis_mobils for the vehicle's own gambar_*, data_trailer_*.data_jenis_mobils
// for the trailer box's gambar_box_* - trailers always match jenis "Trailer", see Trailer::getJenisMobilAttribute
// on the backend) - a real reference photo of that vehicle/trailer type, when one has been uploaded. Falls back
// to the generic outline illustration when the jenis has none.
export const getMarkingReferenceImage = ({ headerData, field, type }) => {
  const side = sideOf(field);
  const isBox = field.startsWith("gambar_box_");

  const jenisSource = isBox
    ? type === "berangkat"
      ? headerData.data_trailer_berangkat
      : headerData.data_trailer_pulang || headerData.data_trailer_berangkat
    : headerData.data_kendaraan;

  const jenis = jenisSource?.data_jenis_mobils?.[0];
  const referencePhoto = jenis?.[`gambar_${side}`];

  return referencePhoto || vehicleOutlinePlaceholders[field] || "";
};
